import { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import React from 'react';

interface Props {
  title: RichTextField;
  description: RichTextField;
}

export const TitleSection = ({ title, description }: Props) => {
  return (
    <div className="mb-20 flex flex-col gap-y-6 max-w-4xl mx-auto">
      <div className="text-left">
        <PrismicRichText field={title} />
      </div>
      <div className="text-left">
        <PrismicRichText
          field={description}
          components={{
            paragraph: ({ children }) => (
              <p className="text-medium-normal">{children}</p>
            ),
          }}
        />
      </div>
    </div>
  );
};
